export default __webpack_public_path__ + "bdf462a08bb8211671805f4c8b5821d4.jpg";